import { Route, Routes} from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import DashboardCitas from '../components/appointment/AppointmentsHomePage';
import ConfirmAppointmentPage from '../pages/appointments/confirmAppointmentPage';


const AppointmentRoutes = () => {
  return (
    <Routes>
      <Route path="confirm" element={<ConfirmAppointmentPage />} />
      <Route path="cancel" element={<ConfirmAppointmentPage />} />

      <Route element={<ProtectedRoute />} >
        <Route path="/home" element={<DashboardCitas />} />
      </Route>
    </Routes>
  );
};
export default AppointmentRoutes;